import enGB from "date-fns/esm/locale/en-GB/index.js";
const dateEnGB = {
  name: 'en-GB',
  locale: enGB
};
export default dateEnGB;